import React, { lazy } from 'react';

const BackTest = lazy(() => import('./back-test/index'));
const Dpk = lazy(() => import('./dpk/index'));
const Lpp = lazy(() => import('./lpp/index'));
const Lcp = lazy(() => import('./lcp/index'));
const LcpPerformance = lazy(() => import('./lcp-performance/index'));
const GhostScheduler = lazy(() => import('./ghost-scheduler/index'));
const LcpPerformanceDetails = lazy(() => import('./lcp-performance/lcp-performance-details/index'));
const CreateLcpTrainingRequest = lazy(() => import('./lcp/create-training-request/index'));

const MachineLearningRoute = () => {

    return [
        {
            key: 'dpk',
            path: '/ml/dpk',
            component: <Dpk />,
        },
        {
            key: 'lpp',
            path: '/ml/lpp',
            component: <Lpp />,
        },
        {
            key: 'lcp',
            path: '/ml/lcp',
            component: <Lcp />,
        },
        {
            key: 'createLcpTrainingRequest',
            path: '/ml/lcp/create/:facilityId/:cellId/:partId',
            component: <CreateLcpTrainingRequest />,
        },
        {
            key: 'backtest',
            path: '/ml/backtest',
            component: <BackTest />,
        },
    ];
};

export default MachineLearningRoute;
